import { render, staticRenderFns } from "./CollaborationAsset.vue?vue&type=template&id=612e9feb&scoped=true&"
import script from "./CollaborationAsset.vue?vue&type=script&lang=js&"
export * from "./CollaborationAsset.vue?vue&type=script&lang=js&"
import style0 from "./CollaborationAsset.vue?vue&type=style&index=0&id=612e9feb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e9feb",
  null
  
)

export default component.exports